var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C10.955 2 2 11.001 2 22.103c0 10.078 7.387 18.401 17.01 19.855V27.43h-4.948v-5.283h4.948V18.63c0-5.821 2.822-8.376 7.635-8.376 2.305 0 3.525.173 4.102.25v4.612h-3.284c-2.043 0-2.756 1.948-2.756 4.142v2.889h5.988l-.812 5.283h-5.176V42C34.468 40.67 42 32.28 42 22.103 42 11.001 33.045 2 22 2z",
    fill: "#000",
    className: "hover"
  })));
}

export default SvgFacebookIconDark;